<template lang="pug">
  #create-or-merge
    .destination-source
      .title-block
        .title Etablissement cible
        .subtitle Choisissez si vous voulez ajouter les fiches à un établissement existant, ou en créer un nouveau
      .destination-source-option(
        :class="{ selected: value === 'new-establishment' }"
        @click="value = 'new-establishment'"
      )
        label.destination-source-radio.radio
          input(type="radio" v-model="value" name="destination-source" value="new-establishment")
          .radio_indicator
        .destination-source-text
          .title Créer un nouvel établissement
          .description Créer un nouvel établissement à partir de toutes les fiches sélectionnées.
      .destination-source-option(
        :class="{ selected: value === 'existing-establishment' }"
        @click="value = 'existing-establishment'"
      )
        label.destination-source-radio.radio
          input(type="radio" v-model="value" name="destination-source" value="existing-establishment")
          .radio_indicator
        .destination-source-text
          .title Déplacer vers un établissement existant
          .description Déplacer toutes les fiches sélectionnées vers un établissement existant.
    .actions
      button.cancel-btn(@click="$emit('close')") Annuler
      button.previous-btn(@click="goBack") Precédent
      button.next-btn(@click="goNext") Suivant
</template>

<script>
export default {
  props: {
    destinationSource: {
      type: String,
      required: true,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'SheetsPreview' });
    },
    goNext() {
      const isNew = this.destinationSource === 'new-establishment';
      const routeName = isNew ? 'CreateEstablishment' : 'TargetEstablishmentChoice';
      this.$router.push({ name: routeName });
    },
  },
  computed: {
    value: {
      get() {
        return this.destinationSource;
      },
      set(value) {
        this.$emit('changeDestinationSource', value);
      },
    },
  },
}
</script>

<style lang="scss">
  #create-or-merge {
    .destination-source {
      flex-grow: 1;
      flex-direction: column;
      display: flex;
      justify-content: center;
      align-items: center;
      .destination-source-option {
        width: 700px;
        display: flex;
        align-items: center;
        margin: 1em 0;
        padding: .5em 2em;
        border: 1px solid #AAAAAA;
        background: #F5F5F5;
        border-radius: 8px;
        cursor: pointer;
        .destination-source-text {
          > div {
            margin: .25em 0;
          }
          .title {
            font-size: 22px;
            font-weight: 500;
          }
          .description {
            font-size: 18px;
            color: #8A8A8A;
          }
        }
        .destination-source-radio {
          margin-right: 2em;
          .radio_indicator {
            margin-top: -7px;
          }
        }
        &.selected {
          background: white;
          border: 2px solid var(--primary);
        }
      }
    }
  }
</style>